import React from 'react';
import ReactQuill from 'react-quill-new';
import 'quill/dist/quill.snow.css';

// Controlled rich text editor shared across forms
const RichTextEditor = ({ value, onChange, placeholder, readOnly }) => {
  return (
    <ReactQuill
      theme="snow"
      value={value || ''}
      onChange={onChange}
      placeholder={placeholder}
      readOnly={readOnly}
    />
  );
};

export default RichTextEditor;